export default __webpack_public_path__ + "static/media/Me Too.58cd4e93.png";